module.exports = __webpack_public_path__ + "resources/img/img_goldilocks3.3f85b1cdcd8216d3b3cf074a6ea300c4.png";